import React, { createContext, useReducer, useContext } from "react";
import BrandsService from "../services/BrandsService";
import BrandsReducer from "../reducers/BrandsReducer";
import { BRANDS_RECEIVED, SET_BRAND } from "../types/brands";
import { ModalContext } from "./ModalContext";

const initialState = {
  brands: null,
  brand: null,
};

export const BrandsContext = createContext(initialState);

export const BrandsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(BrandsReducer, initialState);

  const { alert } = useContext(ModalContext);

  const getBrands = () => {
    BrandsService.getBrands()
      .then((response) => {
        const { brands } = response.data;
        dispatch({
          type: BRANDS_RECEIVED,
          payload: brands,
        });
      })
      .catch((error) => {
        alert(error);
      });
  };

  const setBrand = (brand) => {
    dispatch({ type: SET_BRAND, payload: brand });
  };

  return (
    <BrandsContext.Provider
      value={{
        ...state,
        setBrand,
        getBrands,
      }}
    >
      {children}
    </BrandsContext.Provider>
  );
};

